"use strict";

var _regeneratorRuntime = require("/codebuild/output/src532132034/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _getValueFromGenericInput = require("@devsta/get-value-from-generic-input");

var _clientAwsS = require("@devsta/client-aws-s3");

var _v = _interopRequireDefault(require("uuid/v4"));

var _commonReact = require("@devsta/common-react");

var _lodash = _interopRequireDefault(require("lodash.memoize"));

var _ResizableColumnContainer = _interopRequireDefault(require("../../../components/ResizableColumnContainer"));

var _Sections = require("./Sections");

var _Footer = _interopRequireDefault(require("../../../components/Footer"));

var _utils = require("../utils");

require("../styles/_brief.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var SMALL_BREAKPOINT = 850;

var EMPTY_PRESENTER = function EMPTY_PRESENTER() {
  return {
    name: '',
    title: '',
    description: '',
    imageKey: '',
    presenterId: (0, _v.default)()
  };
};

function getVideoProp(video, name, fallback) {
  return video[name] || fallback;
}

var Brief = /*#__PURE__*/function (_Component) {
  _inherits(Brief, _Component);

  var _super = _createSuper(Brief);

  function Brief(props) {
    var _this;

    _classCallCheck(this, Brief);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "onSave", (0, _lodash.default)(function () {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          shouldContinue = _ref.shouldContinue;

      return (/*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          var _this$props, updateVideo, goToNextStage, onSave, stateWithDefaultedValues, _yield$onSave, error;

          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _this$props = _this.props, updateVideo = _this$props.updateVideo, goToNextStage = _this$props.goToNextStage, onSave = _this$props.onSave;
                  stateWithDefaultedValues = Object.entries(_this.state).reduce(function (defaultedState, _ref3) {
                    var _ref4 = _slicedToArray(_ref3, 2),
                        key = _ref4[0],
                        value = _ref4[1];

                    return _objectSpread({}, defaultedState, _defineProperty({}, key, value || null));
                  }, {});
                  _context.next = 4;
                  return updateVideo(stateWithDefaultedValues);

                case 4:
                  _context.next = 6;
                  return onSave();

                case 6:
                  _yield$onSave = _context.sent;
                  error = _yield$onSave.error;

                  if (!(error || !shouldContinue)) {
                    _context.next = 10;
                    break;
                  }

                  return _context.abrupt("return");

                case 10:
                  goToNextStage();

                case 11:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }))
      );
    }));

    _defineProperty(_assertThisInitialized(_this), "onAddNewPresenter", function () {
      _this.setState(function (_ref5) {
        var presenters = _ref5.presenters;
        return {
          presenters: [].concat(_toConsumableArray(presenters), [EMPTY_PRESENTER()])
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onUpdatePresenter", function (fieldName, index) {
      return function (anyValue) {
        var value = (0, _getValueFromGenericInput.getStringValueFromGenericInput)(anyValue);
        var presenters = _this.state.presenters;

        var newPresenters = _toConsumableArray(presenters);

        var existingPresenter = presenters[index];
        newPresenters.splice(index, 1, _objectSpread({}, existingPresenter, _defineProperty({}, fieldName, value)));

        _this.setState({
          presenters: newPresenters
        });
      };
    });

    _defineProperty(_assertThisInitialized(_this), "onRemovePresenter", function (index) {
      return function () {
        var presenters = _this.state.presenters;

        var newPresenters = _toConsumableArray(presenters);

        newPresenters.splice(index, 1);

        _this.setState({
          presenters: newPresenters
        });
      };
    });

    _defineProperty(_assertThisInitialized(_this), "onSelectBrandValue", (0, _lodash.default)(function (fieldName) {
      return function (_ref6) {
        var _this$setState;

        var value = _ref6.value;

        _this.setState((_this$setState = {}, _defineProperty(_this$setState, fieldName, value), _defineProperty(_this$setState, "lowerThirdTitle", ''), _defineProperty(_this$setState, "lowerThirdDescription", ''), _this$setState));
      };
    }));

    _defineProperty(_assertThisInitialized(_this), "onSelectBrand", function (newBrandId) {
      _this.setState(function (_ref7) {
        var brandId = _ref7.brandId;
        return {
          brandId: brandId === newBrandId ? void 0 : newBrandId,
          lowerThirdId: void 0,
          introAnimationId: void 0,
          lowerThirdTitle: '',
          lowerThirdDescription: ''
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onChangeField", function (fieldName) {
      return function (value) {
        _this.setState(_defineProperty({}, fieldName, (0, _getValueFromGenericInput.getStringValueFromGenericInput)(value)));
      };
    });

    var video = props.video;
    _this.state = {
      presenters: getVideoProp(video, 'presenters', []),
      brandId: getVideoProp(video, 'brandId'),
      lowerThirdId: getVideoProp(video, 'lowerThirdId'),
      introAnimationId: getVideoProp(video, 'introAnimationId'),
      videoType: getVideoProp(video, 'videoType'),
      notesToTheEditor: getVideoProp(video, 'notesToTheEditor'),
      creativeInput: getVideoProp(video, 'creativeInput', 'EXACT'),
      targetAudience: getVideoProp(video, 'targetAudience', ''),
      keyMessage: getVideoProp(video, 'keyMessage', ''),
      callToAction: getVideoProp(video, 'callToAction', ''),
      musicStyle: getVideoProp(video, 'musicStyle', ''),
      videoStyle: getVideoProp(video, 'videoStyle', ''),
      lowerThirdTitle: getVideoProp(video, 'lowerThirdTitle', ''),
      lowerThirdDescription: getVideoProp(video, 'lowerThirdDescription', '')
    };
    return _this;
  }

  _createClass(Brief, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this$props2, apolloClient, organisationId, presenters, presentersWithImages;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this$props2 = this.props, apolloClient = _this$props2.apolloClient, organisationId = _this$props2.video.organisationId;
                presenters = this.state.presenters;
                _context2.next = 4;
                return (0, _clientAwsS.replaceBucketKeysWithUrlsInArray)({
                  apiClient: apolloClient,
                  dataArray: presenters.map(function (presenter) {
                    return _objectSpread({}, presenter, {
                      imageUrl: presenter.imageKey,
                      organisationId: organisationId
                    });
                  }),
                  substitutedKeys: ['imageUrl'],
                  organisationId: organisationId
                });

              case 4:
                presentersWithImages = _context2.sent;
                this.setState({
                  presenters: presentersWithImages
                });

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          goBack = _this$props3.goBack,
          canUpdateVideo = _this$props3.canUpdateVideo,
          video = _this$props3.video,
          apolloClient = _this$props3.apolloClient,
          containerSize = _this$props3.containerSize,
          shouldShowPendingApprovalInformation = _this$props3.shouldShowPendingApprovalInformation,
          shouldShowPendingApprovalButtons = _this$props3.shouldShowPendingApprovalButtons;
      var _this$state = this.state,
          presenters = _this$state.presenters,
          creativeInput = _this$state.creativeInput,
          brandId = _this$state.brandId,
          lowerThirdId = _this$state.lowerThirdId,
          lowerThirdDescription = _this$state.lowerThirdDescription,
          lowerThirdTitle = _this$state.lowerThirdTitle,
          introAnimationId = _this$state.introAnimationId,
          targetAudience = _this$state.targetAudience,
          notesToTheEditor = _this$state.notesToTheEditor,
          keyMessage = _this$state.keyMessage,
          callToAction = _this$state.callToAction,
          musicStyle = _this$state.musicStyle,
          videoStyle = _this$state.videoStyle,
          videoType = _this$state.videoType;
      return (/*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, canUpdateVideo ? /*#__PURE__*/_react.default.createElement(_commonReact.Autosave, {
          data: this.state,
          functionToCall: this.onSave()
        }) : null, /*#__PURE__*/_react.default.createElement("div", {
          className: (0, _classnames.default)('brief', {
            'brief--small': containerSize.width < SMALL_BREAKPOINT
          })
        }, /*#__PURE__*/_react.default.createElement(_ResizableColumnContainer.default, {
          leftProps: {
            title: 'Video Brief',
            icon: 'brief'
          },
          rightProps: {
            title: 'Branding',
            icon: 'brand'
          },
          className: "column",
          preventResize: true
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "brief__column"
        }, /*#__PURE__*/_react.default.createElement(_Sections.EditorBriefSection, {
          notesToTheEditor: notesToTheEditor,
          onChangeField: this.onChangeField,
          videoType: videoType,
          canUpdateVideo: canUpdateVideo,
          organisationId: video.organisationId
        }), /*#__PURE__*/_react.default.createElement(_Sections.CreativeInputSection, {
          onChangeField: this.onChangeField,
          creativeInput: creativeInput,
          canUpdateVideo: canUpdateVideo
        }), /*#__PURE__*/_react.default.createElement(_Sections.IntentSection, {
          callToAction: callToAction,
          onChangeField: this.onChangeField,
          targetAudience: targetAudience,
          keyMessage: keyMessage,
          canUpdateVideo: canUpdateVideo
        }), /*#__PURE__*/_react.default.createElement(_Sections.StyleSection, {
          musicStyle: musicStyle,
          videoStyle: videoStyle,
          onChangeField: this.onChangeField,
          canUpdateVideo: canUpdateVideo
        })), /*#__PURE__*/_react.default.createElement("div", {
          className: "brief__column"
        }, /*#__PURE__*/_react.default.createElement(_Sections.BrandSection, {
          onSelectBrand: this.onSelectBrand,
          brandId: brandId,
          lowerThirdId: lowerThirdId,
          lowerThirdTitle: lowerThirdTitle,
          lowerThirdDescription: lowerThirdDescription,
          onSelectBrandValue: this.onSelectBrandValue,
          onChangeField: this.onChangeField,
          introAnimationId: introAnimationId,
          canUpdateVideo: canUpdateVideo,
          organisationId: video.organisationId
        }), /*#__PURE__*/_react.default.createElement(_Sections.PresentersSection, {
          onAddNewPresenter: this.onAddNewPresenter,
          onUpdatePresenter: this.onUpdatePresenter,
          onRemovePresenter: this.onRemovePresenter,
          presenters: presenters,
          canUpdateVideo: canUpdateVideo,
          video: video,
          apolloClient: apolloClient
        })))), /*#__PURE__*/_react.default.createElement(_Footer.default, {
          buttonText: canUpdateVideo ? 'SAVE & CONTINUE' : 'CONTINUE',
          onBackClick: goBack,
          onNext: this.onSave({
            shouldContinue: true
          }),
          showBriefInformation: !shouldShowPendingApprovalInformation && !shouldShowPendingApprovalButtons,
          nextDisabled: !(0, _utils.isValidBrief)(this.state)
        }))
      );
    }
  }]);

  return Brief;
}(_react.Component);

exports.default = Brief;